import {createSelector} from 'reselect';
import props from '../../../../props';

export default createSelector(
    props.wallet.methods.chime_cashout,
    props.user.user,
    (chime_cashout, user) => {
        return {
            stage: chime_cashout.stage,
            initialized: chime_cashout.initialized,
            works: chime_cashout.works,
            user
        }
    }
)